import React from 'react';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import { Modal, Button, Row, Col, Container, Form } from 'react-bootstrap';
import './forgotPassword.css';
export const ForgotPasswordDialog = ({ show, setShow, flowConfig, usernameOrEmail, setUsernameOrEmail }) => (

  <Modal show={show} onHide={() => setShow(false)} centered >
    <Modal.Header closeButton className='forgot-pwd-close'>
      <Modal.Title
        style={{ textAlign: 'center', width: '100%', color: '#2D3E50', fontFamily: 'Poppins', fontWeight: 600 }}
      >
        Enter Username / Email ID
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="forgot-password-body">
      <Container>
        <Row className="d-flex align-items-center justify-content-center">
          <Col className="p-2 d-flex align-items-center justify-content-center">
            Please Enter Your Registered Username / Email ID
          </Col>
          <Form.Group as={Row} className="pt-3 d-flex align-items-center justify-content-center">
            <Form.Label className="ps-0">Username / Email *</Form.Label>
            <Form.Control
              style={{ boxShadow: 'none' }}
              className='forgot-login-input'
              value={usernameOrEmail}
              onChange={(e) => setUsernameOrEmail(e.target.value)}
            />
          </Form.Group>
        </Row>
        <Row>
          <Col className="p-2 d-flex align-items-center justify-content-center">
            <SigniteButton variant={'primary'} className=" verifyotp-button mt-3 p-3" onClick={() => flowConfig.verify(usernameOrEmail)} >
              Send OTP
            </SigniteButton>
          </Col>
        </Row>
      </Container>
    </Modal.Body>
  </Modal>
);